const app = (state = { connected: false, users: [], isDuplicated: false, plans: [] }, action) =>
{
	switch (action.type)
	{
		case 'SET_CONNECT_STATUS':
		{
			const { connected } = action.payload;

			return { ...state, connected };
		}

		case 'APP_JOIN_REQUEST':
		{
			const { user } = action.payload;

			return { ...state, users: !state.users.some((el) => el.id === user?.id) ? [ ...state.users, user ] : state.users };
		}

		case 'APP_LEAVE_REQUEST':
		{
			const { userId } = action.payload;

			return { ...state, users: state.users.filter((el) => el.id !== userId) };
		}

		case 'SET_DUPLICATED_STATUS':
		{
			return { ...state, isDuplicated: action.payload.isDuplicated };
		}

		case 'SET_APP_PLANS':
		{
			return { ...state, plans: action.payload.plans };
		}

		default:
			return state;
	}
};

export default app;
